<script lang="ts">
/**
 * Labeled list of items not assigned to a sub-container.
 *
 * Used on container detail pages to show items that belong directly
 * to the container (not nested inside a child container).
 *
 * @example
 * ```vue
 * <ContainerLooseItems label="Items in Basement" :items="loose_items" />
 * ```
 */
export interface ContainerLooseItemsProps {
  /** Section header label (e.g. "Items in Basement"). */
  label: string
  /** Loose items from the backend. */
  items: ItemSummary[]
}
</script>

<script setup lang="ts">
import { SbList, SbListLabel } from "@unio/saltbox-ui"

import ListItemRow from "@/components/ListItemRow.vue"
import type { ItemSummary } from "@/types/models"

defineProps<ContainerLooseItemsProps>()
</script>

<template>
  <SbList separator>
    <SbListLabel header>{{ label }}</SbListLabel>
    <ListItemRow v-for="item in items" :key="item.id" :item="item" variant="nested" />
  </SbList>
</template>
